import * as React from 'react'
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material'
import { useStates } from './hooks'

export function StandardStateSelect({
  value,
  onChange,
}: {
  value: string
  onChange: (value: string) => void
}) {
  const { states, loadingStates, fetchStates } = useStates()

  // Fetch states on mount
  React.useEffect(() => {
    if (!states && !loadingStates) {
      fetchStates()
    }
  }, [states, loadingStates, fetchStates])

  return (
    <FormControl fullWidth size="small">
      <InputLabel id="state-select-label">State</InputLabel>
      <Select
        labelId="state-select-label"
        id="state-select"
        value={value}
        label="State"
        onChange={(e: SelectChangeEvent) => onChange(e.target.value)}
      >
        {!states ? (
          <MenuItem disabled>Loading states...</MenuItem>
        ) : (
          states.map((state) => (
            <MenuItem dense key={state.name} value={state.name}>
              {state.name} - {state.desc}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  )
}
